<template>
	<div id="app">
		<template v-if="isRouterAlive">
			<keep-alive>
				<router-view v-if="keepAlive"></router-view>
			</keep-alive>
			<router-view v-if="!keepAlive"></router-view>
		</template>
	</div>
</template>
<script>
	//首页引入base.scss
	import 'ASSETS/scss/common/base.scss'

	export default {
		provide () {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
			return {
				reload: this.reload
			}
		},
		data() {
			return {
				isRouterAlive:false,
			}
		},
		computed:{
			keepAlive(){
				return this.$route.meta.keepAlive
			}
		},
		created() {
			this.getProfile();
		},
		methods: {
			reload() {
				this.isRouterAlive = false;            //先关闭，
				this.$nextTick(function () {
					this.isRouterAlive = true;         //再打开
				}) 
			},
			getProfile(){
				let search = JSON.parse(localStorage.getItem("search"));
				let invite_code = search&&search.invite_code||"";
				this.$http.get('/front/my/profile/?invite_code='+ invite_code+'&app_id='+APP_ID).then(res =>{
					if(res.status=='200'){
						this.$store.commit("setUserInfo",res.data);
						this.$store.commit("setIsLogin",true);
						localStorage.setItem("invite_code", res.data.invite_code);
						localStorage.setItem("user_id",res.data.uid);
						let oldId = localStorage.getItem("user_id");
						if(oldId != res.data.uid){
							localStorage.removeItem("dialogArray");
						}
					}else{
						this.$toast(res.message)
					}
				}).finally(()=>{
					this.isRouterAlive = true;
				})
			},
		},
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	* {
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	}
	#app {
		font-family: "Avenir", Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		margin: 0;
		padding: 0;
	}
	.loading_cover{
		position: fixed;
		width: 100%;
		height: 100%;
		z-index: 1000;
		top: 0;
		left: 0;
		background-color: rgba(0,0,0,0.6);
		.loading_icon{
			position: absolute;
			top: 50%;
			left: 50%;
			width: 100px;
			transform: translate(-50%,-50%);
		}
	}
</style>
